import { RouteObject, Navigate } from 'react-router-dom';

import { BasicRoutes } from './modules/basic';
import { AutomationRoutes } from './modules/automation';
import { EmailRoutes } from './modules/email';
import { CommunicationRoutes } from './modules/communication';
import { CalendarRoutes } from './modules/calendar';
import { DocumentsRoutes } from './modules/documents';
import { AnalyticsRoutes } from './modules/analytics';
import { SecurityRoutes } from './modules/security';
import { ApiRoutes } from './modules/api';
import { AdminRoutes } from './modules/admin';

export const coreRoutes: RouteObject[] = [
  { path: '', element: <Navigate to="basic/contacts" replace /> },
  BasicRoutes,
  AutomationRoutes,
  EmailRoutes,
  CommunicationRoutes,
  CalendarRoutes,
  DocumentsRoutes,
  AnalyticsRoutes,
  SecurityRoutes,
  ApiRoutes,
  AdminRoutes,

  // Backward-compatibility migration redirects
  { path: 'contacts', element: <Navigate to="basic/contacts" replace /> },
  { path: 'companies', element: <Navigate to="basic/companies" replace /> },
  { path: 'relationships', element: <Navigate to="basic/relationships" replace /> },
  { path: 'custom-fields', element: <Navigate to="basic/custom-fields" replace /> },
  { path: 'custom-objects', element: <Navigate to="basic/custom-objects" replace /> },
  { path: 'roles', element: <Navigate to="admin/roles" replace /> },
  { path: 'field-security', element: <Navigate to="security/data-masking" replace /> },
  { path: 'record-access', element: <Navigate to="security/data-residency" replace /> },
  { path: 'audit', element: <Navigate to="admin/audit-log" replace /> },
  { path: 'automations', element: <Navigate to="automation/workflow-builder" replace /> },
  { path: 'schedules', element: <Navigate to="automation/process-automation" replace /> },
  { path: 'views', element: <Navigate to="analytics/report-builder" replace /> },
  { path: 'reports', element: <Navigate to="analytics/dashboards" replace /> },
  { path: 'inbox', element: <Navigate to="communication/in-app-chat" replace /> },
  { path: 'templates', element: <Navigate to="email/templates" replace /> },
  { path: 'activity', element: <Navigate to="security/field-audit-trail" replace /> },
  { path: 'documents', element: <Navigate to="documents/document-management" replace /> },
  { path: 'e-signature', element: <Navigate to="documents/e-signature" replace /> },
  { path: 'ocr', element: <Navigate to="documents/ocr-extraction" replace /> },
  { path: 'users', element: <Navigate to="admin/users" replace /> },
  { path: 'teams', element: <Navigate to="admin/teams" replace /> },
  { path: 'bulk-import', element: <Navigate to="admin/bulk-user-import" replace /> },
  { path: 'api-docs', element: <Navigate to="api/rest-api" replace /> },
  { path: 'webhooks', element: <Navigate to="api/webhooks-console" replace /> },
  { path: 'oauth', element: <Navigate to="api/oauth-apps" replace /> },
  { path: 'settings', element: <Navigate to="admin/org-settings" replace /> },
  { path: 'retention', element: <Navigate to="admin/data-retention" replace /> },
  { path: 'backup', element: <Navigate to="admin/backup-restore" replace /> },
  { path: 'api-keys', element: <Navigate to="api/api-keys" replace /> },
  { path: 'modules', element: <Navigate to="admin/modules-plans" replace /> },
  { path: 'admin/modules-plans', element: <Navigate to="admin/modules-plans" replace /> },
];

export default coreRoutes;
